import ReactDOM from 'react-dom/client';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import Layout from '@/components/templates/Layout';
import Listing from '@/components/templates/Listing';
const rootElement = document.getElementById( 'lm-root' );

if ( rootElement ) {
    const router = createBrowserRouter( [
        {
            path: `${window.relativeHomeURL}/`,
            element: <Layout postType="landing-page" slug="home" />,
        },
        {
            path: `${window.relativeHomeURL}/listing/:listingID`,
            element: <Listing />,
        },
        {
            path: `${window.relativeHomeURL}/:postType/:slug`,
            element: <Layout />,
        },
        {
            path: `${window.relativeHomeURL}/:slug`,
            element: <Layout postType="landing-page" />,
        },
    ] );

    ReactDOM.createRoot( rootElement ).render(
        <RouterProvider router={ router } />
    );
} else {
    console.error( 'Failed to find the root element.' );
}